import { resolveTranslationKey } from './carrouselTranslationKeyResolver';

export function CarrouselButtonGroupHeaderViewConstructor(services, callbacks, context, siteTypeConfig) {
  
  let joint = services.joint;

  return joint.shapes.html.AbstractElementView.extend({
    isElementEditable: false,
    angularTemplate: require('./CarrouselButtonGroupHeaderView.html'),

    getViewLabel: function () {
      const parentView = this.getParentView();
      if (parentView) {
        const button_group_header_label = services.$translate.instant(this.resolveTranslationKey('button_group_header'));
        const indexOnLabel = parentView.getElementIndexAndTotalElementsAsText(this.angularScope.elementData.groupIndex);
        return `${button_group_header_label} ${indexOnLabel}`;
      }
      return '';
    },

    resolveTranslationKey: function (key) {
      return resolveTranslationKey(this.getParentType(), key);
    },


  });
}
